<script lang="ts" setup>
import StatusTag from '@/common/components/molecules/statusTag/StatusTag.vue';

interface Props {
  disabled?: boolean;
}

withDefaults(defineProps<Props>(), {
  disabled: false,
});
</script>

<template>
  <status-tag
    :type="disabled ? 'disabled' : 'succeeded'"
    class="live-tag"
  >
    Live
  </status-tag>
</template>

<style lang="scss" scoped>
.live-tag {
  display: inline-flex;
  align-items: center;
  min-width: unset;
  height: 16px;
  padding: 0 6px;
  line-height: normal;
}
</style>
